import axios from 'axios';
import { API_URL } from '../../../config/config';

// Service for Login admin
const signin = async (loginData) => {
	const response = await axios.post(`${API_URL}/auth/login`, loginData);
	if (response.data) {
		localStorage.setItem('token', JSON.stringify(response.data.token));
	}
	return response.data;
};

const signOut = async () => {
	localStorage.clear();
};

const authService = {
	signin,
	signOut,
};

export default authService;
